import { render, staticRenderFns } from "./ModalCertifications.vue?vue&type=template&id=4763a56c&lang=pug&"
import script from "./ModalCertifications.vue?vue&type=script&lang=js&"
export * from "./ModalCertifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports